import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {AbstractProdGrid, IProdGrid, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {DipColumn} from "../../dip/dip-column";
import {UserFormComponent} from "./form/user-form.component";
import {OrganizationService} from "../../services/organization.service";
import {OrganizationTreeSelect} from "../../dip/organization-tree-select";
import {HttpExtraParams} from "prod-shared";
import {Role} from "../../dip/role";
import {RoleService} from "../../services/role.service";
import {UserGroupService} from "../../services/user-group.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html'
})
export class UsersComponent extends AbstractProdGrid implements IProdGrid, OnInit {
  @Input() companyTab: boolean = false;
  prodGridTitle: string = this.translate.instant('users.grid_title');
  isAddButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_USER_EDIT]);
  isRemoveButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_USER_DELETE]);
  override prodGridForm = {
    component: UserFormComponent,
    style: {height: '60%', width: '65%'},
    editStyle: {height: '60%', width: '65%'}
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({
      property: 'username', type: ProdGridColumnType.SELECT_COMPONENT,
      selectParameters: {
        selectDataService: UserService,
        isMulti: true,
        isNarrowDown: true,
        isComplete: true,
      },
      isSelfFilter: true
    }),
    DipColumn.get({property: 'firstName', type: ProdGridColumnType.STRING}),
    DipColumn.get({property: 'lastName', type: ProdGridColumnType.STRING}),
    DipColumn.get({
      property: 'groups',
      type: ProdGridColumnType.SELECT_COMPONENT,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false,
      selectParameters: {
        selectDataService: UserGroupService,
        isComplete: true,
        isNarrowDown: true,
        isMulti: true
      }
    }),
    DipColumn.get({
      property: 'notifierOrganizations',
      type: ProdGridColumnType.SELECT_COMPONENT,
      transform: {
        transform: ProdGridColumnTransforms.ARRAY_JOIN,
        option: 'name'
      },
      sortable: false,
      selectParameters: {
        selectDataService: OrganizationService,
        isNarrowDown: true,
        isMulti: true,
        isComplete: true
      }
    }),
    DipColumn.get({
      property: 'lastLogin',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    })
  ];

  constructor(protected override changeDetectorRef: ChangeDetectorRef,
              override prodGridDataService: UserService,
              public organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private translate: TranslateService) {
    super(changeDetectorRef);
    organizationTreeSelect.gridComponent = this;

    if (roleService.hasRole([Role.ROLE_SYS])) {
      this.prodGridColumns.push(
        DipColumn.get({
          property: 'isEnabled',
          type: ProdGridColumnType.CHECKBOX,
          transform: {
            transform: ProdGridColumnTransforms.TICK
          }
        }),
        DipColumn.get({
          property: 'isDeleted',
          type: ProdGridColumnType.CHECKBOX,
          transform: {
            transform: ProdGridColumnTransforms.TICK
          }
        })
      );
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    super.loadProdGridData(HttpExtraParams.addFilter(httpExtraParams, this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)));
  }

  ngOnDestroy() {
    this.organizationTreeSelect.gridComponent = null;
  }
}
